module.exports = __webpack_public_path__ + "static/media/insect(10).d944099a.PNG";